/**
 * Per-value-chain-stage accent colors for the asset table (redesign, Tab 1).
 *
 * DELIBERATE DEVIATION from docs/design-guidelines.md "Color": that table
 * reserves blue for Social, amber for warning/draft and violet for a rare
 * single-purpose accent. The redesign uses those hues as *value chain stage*
 * keys instead. Recorded there under "Open questions" — if the team prefers
 * to keep the documented meanings, collapse this to one neutral badge style
 * and the table still reads fine (stage name carries the information).
 *
 * Assignment is positional, not name-based, because the stage taxonomy still
 * has unresolved items (spec §7 / no-building-against-open-spec-items.md:
 * Energy value-chain mismatch, unmapped "Substation", the split Agriculture
 * "Marketing & sales" row). Positional assignment degrades gracefully when
 * those land; a name-keyed map would silently lose its colors.
 */
export const STAGE_ACCENTS = [
  { dot: "bg-primary", badge: "border-primary bg-primary/10 text-primary" },
  { dot: "bg-blue-600", badge: "border-blue-200 bg-blue-50 text-blue-800" },
  { dot: "bg-amber-600", badge: "border-amber-200 bg-amber-50 text-amber-800" },
  { dot: "bg-purple-600", badge: "border-purple-200 bg-purple-50 text-purple-800" },
  { dot: "bg-emerald-600", badge: "border-emerald-200 bg-emerald-50 text-emerald-800" },
  { dot: "bg-indigo-600", badge: "border-indigo-200 bg-indigo-50 text-indigo-800" },
] as const;

/** Stable index into STAGE_ACCENTS; unmapped stages fall back to slot 0. */
export function stageAccentIndex(
  stageId: string | null,
  stages: { id: string }[]
): number {
  if (!stageId) return 0;
  const position = stages.findIndex((stage) => stage.id === stageId);
  if (position < 0) return 0;
  return position % STAGE_ACCENTS.length;
}
